import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

const Dashboard = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState({
    users: 0,
    quotationsToday: 0,
    quotationsThisMonth: 0,
    totalQuotations: 0,
  });
  const [recentQuotations, setRecentQuotations] = useState([]);

  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      const res = await api.get('/reports/stats');
      setStats(res.data);

      const qRes = await api.get('/quotations?limit=50');
      console.log("quotations API result:", qRes.data?.quotations);
      setRecentQuotations(qRes.data?.quotations);
    } catch (err) {
      console.error('Error loading dashboard:', err);
    }
  };

  return (
    <div className="p-6 space-y-8">
      <h2 className="text-2xl font-bold">Dashboard</h2>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <StatCard label="Staff Users" value={stats.users} />
        <StatCard label="Today's Quotations" value={stats.quotationsToday} />
        <StatCard label="This Month" value={stats.quotationsThisMonth} />
        <StatCard label="Total Quotations" value={stats.totalQuotations} />
      </div>

      <div className="mt-4">
        <h3 className="text-xl font-semibold mb-2">Recent Quotations</h3>
        <div className="overflow-x-auto">
          <table className="w-full bg-white shadow rounded text-sm border">
            <thead className="bg-gray-100 text-left">
              <tr>
                <th className="p-2 border">Date</th>
                <th className="p-2 border">Quotation No</th>
                <th className="p-2 border">Customer</th>
                <th className="p-2 border">Amount</th>
              </tr>
            </thead>
            <tbody>
              {recentQuotations?.map((q: any) => (
                <tr key={q?._id}>
                  <td className="p-2 border">{new Date(q?.date).toLocaleDateString()}</td>
                  <td className="p-2 border">{q?.quotationNo}</td>
                  <td className="p-2 border">{q?.billTo?.name}</td>
                  <td className="p-2 border">₹{q?.totalAmount?.toFixed(2)}</td>
                </tr>
              ))}
              {recentQuotations.length === 0 && (
                <tr>
                  <td className="p-2 border" colSpan={4}>No quotations found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const StatCard = ({ label, value }: { label: string; value: number }) => (
  <div className="bg-blue-100 text-blue-900 p-4 rounded-xl text-center shadow">
    <p className="text-md">{label}</p>
    <p className="text-2xl font-bold">{value}</p>
  </div>
);

export default Dashboard;


// import { useEffect, useState } from 'react';

// const Dashboard = () => {
//   const [user, setUser] = useState<{ name: string; role: string } | null>(null);

//   useEffect(() => {
//     // Fetch user from localStorage (set during login)
//     const userData = localStorage.getItem('user');
//     if (userData) {
//       setUser(JSON.parse(userData));
//     }
//   }, []);

//   if (!user) {
//     return <p className="text-center mt-20">Unauthorized. Please login.</p>;
//   }

//   return (
//     <div className="p-6">
//       <h1 className="text-3xl font-bold mb-4">Welcome, {user.name}</h1>
//       <p className="text-gray-600">Role: {user.role}</p>

//       <div className="mt-8">
//         {user.role === 'admin' && (
//           <p>👑 You can edit MRP, download reports, manage users.</p>
//         )}
//         {user.role === 'manager' && (
//           <p>📋 You can generate quotations and manage inventory.</p>
//         )}
//         {user.role === 'staff' && (
//           <p>🛒 You can view products and prepare quotations.</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Dashboard;

